var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 6.66667H12.5093C12.7366 6.66667 12.96 6.72476 13.1585 6.83542C13.357 6.94607 13.5239 7.10562 13.6434 7.29891C13.7629 7.4922 13.831 7.71283 13.8413 7.93984C13.8515 8.16686 13.8036 8.39272 13.702 8.596L11.3687 13.2627C11.2579 13.4843 11.0876 13.6707 10.8768 13.8009C10.666 13.9312 10.4231 14.0001 10.1753 14H7.49733C7.38867 14 7.28 13.9867 7.174 13.96L4.66667 13.3333M9.33333 6.66667V3.33333C9.33333 2.97971 9.19286 2.64057 8.94281 2.39052C8.69276 2.14048 8.35362 2 8 2H7.93667C7.60333 2 7.33333 2.27 7.33333 2.60333C7.33333 3.07933 7.19267 3.54467 6.928 3.94067L4.66667 7.33333V13.3333M9.33333 6.66667H8M4.66667 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V8C2 7.64638 2.14048 7.30724 2.39052 7.05719C2.64057 6.80714 2.97971 6.66667 3.33333 6.66667H5",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpOutline);
export default __webpack_public_path__ + "static/media/ThumbUpOutline.20c506dc73bc3c4d861fb29cc9af3aac.svg";
export { ForwardRef as ReactComponent };